import React, { useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ActionButtons from './ActionButtons';
import { hasAdminAccess } from '../utils/authUser';
import './ChatPage.css';
import './FleetChatTheme.css';

const ChatPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState(null);
  const closeDetailRef = useRef(null);
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (error) {
        return null;
      }
    }
    return null;
  });
  const [isAdmin, setIsAdmin] = useState(() => {
    return hasAdminAccess(user);
  });

  const handleBack = () => {
    if (closeDetailRef.current && closeDetailRef.current()) return;
    navigate('/');
  };

  return (
    <div className="chat-page">
      <ActionButtons 
        activeSection={activeSection} 
        setActiveSection={setActiveSection}
        user={user}
        isAdmin={isAdmin}
        setUser={setUser}
        setIsAdmin={setIsAdmin}
        hidePrompts={false}
        closeDetailRef={closeDetailRef}
        isFullPage={true}
        initialLogin={searchParams.get('login') === '1'}
        onBack={handleBack}
      />
    </div>
  );
};

export default ChatPage;
